export default "__VITE_ASSET__DQfT4KBR__"